import { render, staticRenderFns } from "./router.vue?vue&type=template&id=5eecd774&scoped=true&"
var script = {}
import style0 from "./router.vue?vue&type=style&index=0&id=5eecd774&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eecd774",
  null
  
)

export default component.exports